import { FC, useState } from 'react'

import { Avatar, Box, Button, Tag, Text } from '@factorialco/deprecated-design-system'
import { PeopleChartEmployeesFragment } from 'generated/resources/graphql'

import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

interface Props {
  employee: PeopleChartEmployeesFragment
  onAddMember: () => void
  membershipId: number | null
  deleteMembership: () => void
}

const Row: FC<Props> = ({ employee, onAddMember, membershipId, deleteMembership }) => {
  const [isHovered, setIsHovered] = useState(false)

  return (
    <Box
      key={employee.id}
      flexDirection="row"
      gap="s12"
      paddingX="s16"
      paddingY="s12"
      cursor="pointer"
      alignItems="center"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Box>
        <Avatar size="s32" label={employee.fullName} url={buildUrl(employee.access?.avatar)} />
      </Box>
      <Box>
        <Text.Normal weight="bold">{employee.fullName}</Text.Normal>
        <Text.Normal>{employee.referenceContract?.jobTitle}</Text.Normal>
      </Box>
      {isHovered && (
        <Box style={{ marginLeft: 'auto' }}>
          {membershipId ? (
            <Tag
              type="viridian"
              icon="add"
              leftItem="circle"
              onClose={deleteMembership}
              rightItem="close"
              size="normal"
              showCircle
            >
              {i18n.t('people_chart.employees_selector.member')}
            </Tag>
          ) : (
            <Button onClick={onAddMember} type="secondary" iconName="add">
              {i18n.t('common.add')}
            </Button>
          )}
        </Box>
      )}
    </Box>
  )
}

export default Row
